<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <base-widget
    icon="bar-chart-fill"
    :loading="isLoading"
    :title="$t('dashboard.subunit_attendance_trend')"
  >
    <dashboard-stacked-bar-chart
      :labels="chartLabels"
      :series="chartSeries"
      :x-axis-label="$t('dashboard.clock_in_time')"
      :y-axis-label="$t('dashboard.number_of_clock_ins')"
      :show-legend="false"
      wrapper-classes="emp-subunit-attendance-chart"
    ></dashboard-stacked-bar-chart>
  </base-widget>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';
import DashboardStackedBarChart from '@/orangehrmDashboardPlugin/components/DashboardStackedBarChart.vue';
import {CHART_COLORS} from '@ohrm/oxd';

const SERIES_COLORS = [
  CHART_COLORS.COLOR_HEAT_WAVE,
  CHART_COLORS.COLOR_CHROME_YELLOW,
  CHART_COLORS.COLOR_YELLOW_GREEN,
  CHART_COLORS.COLOR_MOUNTAIN_MEADOW,
  CHART_COLORS.COLOR_PACIFIC_BLUE,
  CHART_COLORS.COLOR_BLEU_DE_FRANCE,
  CHART_COLORS.COLOR_MAJORELLE_BLUE,
  CHART_COLORS.COLOR_MEDIUM_ORCHID,
  CHART_COLORS.COLOR_FANDANGO_PINK,
];

export default {
  name: 'EmployeeLocationWidget',

  components: {
    'base-widget': BaseWidget,
    'dashboard-stacked-bar-chart': DashboardStackedBarChart,
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/dashboard/employees/subunit-attendance-trend',
    );

    return {
      http,
    };
  },

  data() {
    return {
      chartLabels: [],
      chartSeries: [],
      isLoading: false,
    };
  },

  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;

        this.chartLabels = data.labels ?? [];
        this.chartSeries = (data.series ?? []).map((item, index) => ({
          label: item.subunit?.name ?? `Sub Unit ${index + 1}`,
          values: item.values ?? [],
          color: SERIES_COLORS[index % SERIES_COLORS.length],
        }));
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.emp-subunit-attendance-chart {
  width: auto;
  height: 100%;
  min-height: 0;
}
</style>
